import { render } from "./Centers.vue?vue&type=template&id=408f03c0"
import script from "./Centers.vue?vue&type=script&lang=js"
export * from "./Centers.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/moncasan_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__